// Duck-typed contract for the NodeCG browser client. The real type lives in
// @nodecg/types but we don't need most of it — keeping the surface narrow
// makes the panel bundle slim and decouples us from upstream typing churn.

export type NodeCGReplicant<T> = {
  value: T | undefined;
  on(event: "change", cb: (newVal: T | undefined, oldVal: T | undefined) => void): void;
  removeListener?(
    event: "change",
    cb: (newVal: T | undefined, oldVal: T | undefined) => void,
  ): void;
};

export type NodeCGClient = {
  bundleName: string;
  Replicant<T>(name: string): NodeCGReplicant<T>;
  listenFor(name: string, handler: (data: unknown) => void): void;
  sendMessage(
    name: string,
    data: unknown,
    cb?: (err: unknown, response?: unknown) => void,
  ): Promise<unknown>;
};

declare global {
  interface Window {
    nodecg?: NodeCGClient;
  }
}

/** Resolve `window.nodecg` lazily so calling code can run in non-NodeCG
 *  contexts (tests, isolated previews) without crashing. */
export function getNodeCG(): NodeCGClient | null {
  return typeof window !== "undefined" ? window.nodecg ?? null : null;
}
